<template>
  <router-view />
</template>
<script setup>
import { onMounted, watch } from "vue";
import { setCssVar } from "quasar";
import { usePostMessage } from "./composables/useMessage";
import { storeToRefs } from "pinia";
import { useCartStore, useBrandingStore, useStorageStore } from "./store";

const cartStore = useCartStore();
const storageStore = useStorageStore();

const { setCart } = cartStore;

const { token } = storeToRefs(storageStore);
const { setToken, setPaymentMethods, setConfiguration } = storageStore;

const branding = useBrandingStore();
const { colors } = storeToRefs(branding);
const { setColors, setLogo, setHostname, setShop } = branding;

const { sendMessage, messageData } = usePostMessage("*");

const getCardInfo = () => {
  sendMessage({ type: "cart-info" });
};

const getMetadata = () => {
  sendMessage({ type: "send-metadata" });
};

const getToken = () => {
  sendMessage({ type: "send-token" });
};

watch(messageData, (data) => {
  if (data?.data) {
    switch (data?.type) {
      case "send-metadata__response":
        setColors(data.data?.colors);
        setLogo(data.data?.logo);
        setHostname(data.data?.domain);
        setShop(data.data?.shop);
        break;
      case "cart-info__response":
        setCart(data.data);
        break;
      case "send-token__response":
        setToken(data.data?.access_token);
        setPaymentMethods(data.data?.payment_methods);
        setConfiguration(data.data?.checkout_config);
        break;
      default:
        break;
    }
  }
});

watch(token, (token) => {
  if (!token) {
    getToken();
  }
});
watch(colors, (colors) => {
  if (colors) {
    setCssVar("primary", colors.primary);
    setCssVar("secondary", colors.secondary);
  }
});

onMounted(() => {
  getCardInfo();
  getMetadata();
  setTimeout(() => {
    getToken();
  }, 2500);
});
</script>
